<template>
  <button type="button" class="DropdownOptions handle btn btn-light d-flex" id="multi-select-handle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="showDropdown = true">
    <div class="content-wrapper d-flex">
      <span class="content-padding px-2 d-flex align-items-center">
        <slot></slot>
      </span>

      <div v-if="!removeArrow" class="arrow-wrapper content-padding">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 20 20" fill="#999999">
          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </div>
    </div>

    <transition name="fade-trans">
      <ul v-if="showDropdown"
        class="dropdown-menu list-wrapper"
      >
        <li v-for="item in dropdownList"
          :key="item.id"
          :id="item.id || item.value"
          @click="clickDropdownOption(item)"
        >
          <button
            class="dropdown-item d-flex justify-content-between align-items-center pr-3"
            :class="{'active-option': value && value === item.id}"
          >
            <span>
              <slot :name="item.id"></slot>
              
              {{ item.name }}
              <span v-if="showId" class="dropdown-id">
                {{ item.id }}
              </span>
            </span>

            <svg v-if="value && value === item.id" xmlns="http://www.w3.org/2000/svg" width="24" height="24" class="check" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </button>
        </li>
      </ul>
    </transition>
  </button>
</template>

<script>

export default {
  props: {
    value: String,
    options: Array,
    showId: Boolean,
    removeArrow: Boolean,
  },
  data() {
    return {
      showDropdown: false,
    }
  },
  methods: {
    clickDropdownOption(item) {
      if (item.action) return item.action()
      this.selectListItem(item)
    },
    selectListItem(item) {
      this.$emit("input", item.id)
    },
    onClick(evt) {
      const path = evt.composedPath()
      let found
      for (const node of path) {
        if (node === this.$el) {
          found = true
          break
        }
      }

      if (!found) this.showDropdown = false
    },
  },
  computed: {
    dropdownList() {
      return this.options.map(opt => ({
        ...opt,
        id: opt.id || opt.value,
        name: opt.name || opt.str,
      }))
    },
  },
  watch: {
    showDropdown(val) {
      if (val) {
        window.addEventListener("click", this.onClick, {passive: true})
      } else {
        window.removeEventListener("click", this.onClick)
      }
    },
  },
}

</script>

<style>

.DropdownOptions .dropdown-item svg {
  color: rgb(200,200,200) !important;
}

</style>

<style scoped>

.DropdownOptions {
  padding: 0px !important;
}

.content-padding {
  padding: 8.5px 10px;
}

.arrow-wrapper {
  border-left: 1px solid rgba(0, 0, 0, 0.125);
  height: 100%;
}

.dropdown-id {
  color: #9A9A9A;
}

.handle {
  border: 1px solid rgba(0, 0, 0, 0.125);
  background-color: white !important;
  border-radius: 1px !important;
  font-size: 0.75em;
  overflow: visible;
  position: relative;
}

.dropdown-item {
  padding-left: 12px;
  padding-right: 0px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.dropdown-item.active-option {
  font-weight: bold;
}

.check {
  color: #0081c7 !important;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  display: block !important;
  opacity: 1;
  visibility: visible !important;
  padding: 8px 0;
  border-radius: 1px;
  min-width: 16em;
}

.list-wrapper {
  max-height: 470px;
  overflow: auto;
}

</style>
